
import Vue from "vue";

const END_POINT = "/page";

const getPage = id => Vue.axios.get(END_POINT + "/" + id);

const getAllPages = data => Vue.axios.get(END_POINT, { params: data });

const getAllMenuGroups = () => Vue.axios.get(END_POINT, {
  params: {
    pageIndex: 0,
    pageSize: 100, groupOnly: true
  }
});

const createPage = page => Vue.axios.post(END_POINT, page);

const createAllPages = Pages => Vue.axios.post(END_POINT + "/all", Pages);

const updatePage = page => Vue.axios.put(END_POINT + "/" + page.id, page);

const deletePage = id => Vue.axios.delete(END_POINT + "/" + id);

export {
  getPage,
  getAllPages,
  getAllMenuGroups,
  createPage,
  createAllPages,
  updatePage,
  deletePage
};
